import React, { useState, useEffect } from "react";
import "./setupLocation.css";
import { useNavigate } from "react-router-dom";
import {
  resetOnboardingInfo,
  updateOnboardingInfo,
} from "../../redux/attorneyOnboardingSlice";
import { useDispatch, useSelector } from "react-redux";
import BackIcon from "./assets/backIcon.png";
import AddIcon from "./assets/addIcon.png";
import IconCheckbox from "../../components/input/new/iconCheckbox";
import RadioButton from "../../components/input/new/radioButton";
import AddLocationModal from "./addLocationModal";
import AddVideoLocationModal from "./addVideoLocationModal";
import StepFooter from "./stepFooter";
import { authenticatedFetch } from "../../network/api";

const SetupLocations = () => {
  const userId = useSelector(
    (state) => state.attorneyData.attorneyData?.user_id
  );
  const firmId = useSelector(
    (state) => state.attorneyData.attorneyData?.firm_id
  );

  const handleAddLocation = (newLocation) => {
    // Transform the location object to match the expected format
    const transformedLocation = {
      location_name: newLocation.name || newLocation.location_name,
      address: newLocation.address,
      city: newLocation.city,
      state: newLocation.state,
      zip: newLocation.zip,
      latitude: newLocation.latitude,
      longitude: newLocation.longitude,
      contactName: newLocation.contactName,
      notifEmail: newLocation.notifEmail,
      notifPhone: newLocation.notifPhone,
    };
    
    // Update the local state with the new location details.
    setLocations((prev) => [...prev, transformedLocation]);
    // Optionally, auto-select the newly added location.
    setSelectedLoc(transformedLocation);
    // Hide the modal after adding.
    setIsModalOpen(false);
  };

  const handleAddVideoLocation = (newLocation) => {
    // Transform the location object to match the expected format
    const transformedLocation = {
      location_name: newLocation.name || newLocation.location_name,
      platform: newLocation.platform,
      state: newLocation.state,
      contactName: newLocation.contactName,
      notifEmail: newLocation.notifEmail,
      notifPhone: newLocation.notifPhone,
    };
    
    // Update the local state with the new location details.
    setVideoLocations((prev) => [...prev, transformedLocation]);
    // Optionally, auto-select the newly added location.
    setSelectedVideoLoc(transformedLocation);
    // Hide the modal after adding.
    setIsVideoModalOpen(false);
  };

  const [inPerson, setInPerson] = useState(false);
  const [videoVisit, setVideoVisit] = useState(false);
  const [selectedLoc, setSelectedLoc] = useState({});
  const [selectedVideoLoc, setSelectedVideoLoc] = useState({});
  const disableStepFooter =
    (inPerson && Object.keys(selectedLoc).length === 0) ||
    (videoVisit && Object.keys(selectedVideoLoc).length === 0);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false); // State to control modal visibility

  // Holds the fetched locations
  const [locations, setLocations] = useState([]);
  const [videoLocations, setVideoLocations] = useState([]);

  const openLocationModal = () => {
    setIsModalOpen(true); // Open the modal when the location card is clicked
  };

  const closeLocationModal = () => {
    setIsModalOpen(false); // Close the modal
  };
  const openVideoLocationModal = () => {
    setIsVideoModalOpen(true); // Open the modal when the location card is clicked
  };

  const closeVideoLocationModal = () => {
    setIsVideoModalOpen(false); // Close the modal
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNext = () => {
    // Dispatch any final data or handle navigation
    console.log("Still working on this ");
    dispatch(
      updateOnboardingInfo({
        inPerson,
        videoVisit,
        selectedLoc,
        selectedVideoLoc,
      })
    );
  };

  const goBackToProfessionals = () => {
    // Optional extra logic here
    dispatch(resetOnboardingInfo());
    navigate(`/attorney/${userId}/home`);
  };

  // This function can be called when in-person is toggled to "true"
  const handleInPersonChange = async (checked) => {
    setInPerson(checked);

    if (!checked) {
      // Clear locations when unchecked
      setLocations([]);
      setSelectedLoc({});
      return;
    }

    try {
      const response = await authenticatedFetch(
        `/api/attorney/webapp/fetchFirmLocations?firmId=${firmId}&method=person`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching in-person locations: ${response.statusText}`
        );
      }

      const data = await response.json();
      console.log("Fetched in-person data:", data);

      // Normalize into an array of location objects
      let list = [];
      if (Array.isArray(data)) {
        list = data.filter(item => item && item.location_name); // Filter out empty/null items
      } else if (data && Array.isArray(data.locations)) {
        list = data.locations.filter(item => item && item.location_name);
      } else if (data && typeof data === "object" && data.location_name) {
        list = [data];
      }

      setLocations(list);
    } catch (error) {
      console.error("Error fetching in-person locations:", error);
      setLocations([]); // fallback on error
    }
  };

  const handleVideoChange = async (checked) => {
    setVideoVisit(checked);

    if (!checked) {
      // Clear out locations if they un-check
      setVideoLocations([]);
      setSelectedVideoLoc({});
      return;
    }

    try {
      const response = await authenticatedFetch(
        `/api/attorney/webapp/fetchFirmLocations?firmId=${firmId}&method=video`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching video locations: ${response.statusText}`
        );
      }

      const data = await response.json();
      console.log("Fetched video data:", data);

      // Normalize into an array of location objects
      let list = [];
      if (Array.isArray(data)) {
        list = data.filter(item => item && item.location_name); // Filter out empty/null items
      } else if (data && Array.isArray(data.locations)) {
        list = data.locations.filter(item => item && item.location_name);
      } else if (data && typeof data === "object" && data.location_name) {
        list = [data];
      }

      setVideoLocations(list);
    } catch (error) {
      console.error("Error fetching video locations:", error);
      setVideoLocations([]); // fallback on error
    }
  };

  return (
    <div className="locations-container">
      {/* Breadcrumb / Navigation */}
      <div className="category-profile-types">
        <div style={{ display: "flex", flexDirection: "column", width: "40%" }}>
          <div className="category-breadcrumb" onClick={goBackToProfessionals}>
            <img
              src={BackIcon}
              alt="Back Icon"
              style={{ width: "24px", height: "24px" }}
            />
            <a className="category-back-link">Back to professionals</a>
          </div>
          <h1 className="locations-title">Let's set up your locations</h1>

          <p className="locations-questions">What visits do you accept?</p>
          <p className="locations-gray-subtitle">
            What service do you use to conduct video visits?
          </p>

          <div style={{ height: "1.5rem" }} />

          <IconCheckbox
            label="In-person"
            checked={inPerson}
            onChange={handleInPersonChange} // Updated onChange
          />

          <div style={{ marginBottom: "2rem" }} />

          <IconCheckbox
            label="Video visit"
            checked={videoVisit}
            onChange={handleVideoChange}
          />

          <div style={{ marginBottom: "2rem" }} />

          {/* Conditionally render in-person section */}
          {inPerson && (
            <div className="location-section">
              <hr className="h-rule" />
              <h2 className="locations-second-title">In-person location</h2>

              {/* If we have no locations, show the "no locations yet" UI */}
              {locations.length === 0 ? (
                <button
                  className="add-location-btn"
                  onClick={openLocationModal}
                >
                  <img
                    src={AddIcon}
                    style={{ height: "20px", width: "20px" }}
                    alt="Add icon"
                  />
                  Add location
                </button>
              ) : (
                /* If locations exist, render them */
                <div>
                  {/* Example of grouping by state or just listing them out */}
                  {locations
                    .filter(loc => loc && loc.location_name && loc.location_name.trim() !== '')
                    .map((loc, i) => (
                    <RadioButton
                      key={i}
                      label={loc.location_name}
                      value={loc.location_name}
                      checked={selectedLoc.location_name === loc.location_name}
                      onChange={() => setSelectedLoc(loc)}
                    />
                  ))}
                  <div style={{ height: "1.5rem" }} />

                  <button
                    className="add-location-btn"
                    onClick={openLocationModal}
                  >
                    <img
                      src={AddIcon}
                      style={{ height: "20px", width: "20px" }}
                      alt="Add icon"
                    />
                    Add location
                  </button>
                </div>
              )}

              <hr className="h-rule" />
            </div>
          )}

          {videoVisit && (
            <div className="location-section">
              <hr className="h-rule" />
              <h2 className="locations-second-title">
                Video consult locations
              </h2>

              {/* If we have no locations, show the "no locations yet" UI */}
              {videoLocations.length === 0 ? (
                <button
                  className="add-location-btn"
                  onClick={openVideoLocationModal}
                >
                  <img
                    src={AddIcon}
                    style={{ height: "20px", width: "20px" }}
                    alt="Add icon"
                  />
                  Add location
                </button>
              ) : (
                /* If locations exist, render them */
                <div>
                  {/* Example of grouping by state or just listing them out */}
                  {videoLocations
                    .filter(loc => loc && loc.location_name && loc.location_name.trim() !== '')
                    .map((loc, i) => (
                    <RadioButton
                      key={i}
                      label={loc.location_name}
                      value={loc.location_name}
                      checked={
                        selectedVideoLoc &&
                        selectedVideoLoc.location_name === loc.location_name
                      }
                      onChange={() => setSelectedVideoLoc(loc)}
                    />
                  ))}
                  <div style={{ height: "1.5rem" }} />

                  <button
                    className="add-location-btn"
                    onClick={openVideoLocationModal}
                  >
                    <img
                      src={AddIcon}
                      style={{ height: "20px", width: "20px" }}
                      alt="Add icon"
                    />
                    Add location
                  </button>
                </div>
              )}

              <hr className="h-rule" />
            </div>
          )}

          {/* Modal for adding a location */}
          <AddVideoLocationModal
            isOpen={isVideoModalOpen}
            onClose={closeVideoLocationModal}
            onAddLocation={handleAddVideoLocation}
          />
          <AddLocationModal
            isOpen={isModalOpen}
            onClose={closeLocationModal}
            onAddLocation={handleAddLocation}
          />
        </div>
      </div>
      <StepFooter
        currentStep={4}
        totalSteps={9}
        location="/attorney/setup/education"
        onNext={handleNext}
        disabled={disableStepFooter}
      />
    </div>
  );
};

export default SetupLocations;
